export const getDisplayPrice = (item: any, simple?: any) => {
  const target = simple || item
  const price = Number(target?.price || 0)
  const specialPrice = Number(target?.specialPrice || 0)
  const hasSpecialPrice = specialPrice > 0 && specialPrice < price

  return {
    price,
    specialPrice,
    hasSpecialPrice,
    priceToShow: hasSpecialPrice ? specialPrice : price
  }
}

export const getDiscountPercentage = (price: number, specialPrice: number) => {
  const originalPrice = Number(price || 0)
  const salePrice = Number(specialPrice || 0)

  if (!originalPrice || !salePrice || salePrice >= originalPrice) {
    return 0
  }

  return Math.round((1 - salePrice / originalPrice) * 100)
}

const hasSalePrice = (item: any) => {
  return Number(item?.specialPrice || 0) > 0 && Number(item?.specialPrice || 0) < Number(item?.price || 0)
}

export const mergeProductDisplayPricing = (target: any, source: any) => {
  if (!target || !source) {
    return target
  }

  if (hasSalePrice(source) && !hasSalePrice(target)) {
    target.specialPrice = source.specialPrice
  }

  if (!target.price && source.price) {
    target.price = source.price
  }

  const sourceSimples = new Map(
    (source.simpleProducts || []).map((simple: any) => [simple.sku || simple.id, simple])
  )

  target.simpleProducts = (target.simpleProducts || []).map((simple: any) => {
    const sourceSimple: any = sourceSimples.get(simple.sku || simple.id)

    if (!sourceSimple) {
      return simple
    }

    if (!simple.price && sourceSimple.price) {
      simple.price = sourceSimple.price
    }

    if (hasSalePrice(sourceSimple) && !hasSalePrice(simple)) {
      simple.specialPrice = sourceSimple.specialPrice
    }

    return simple
  })

  return target
}
